<template>
	<div class="c-sample-product__btn-container">
		<button class="e-button e-button--filled c-sample-product__order-btn"
			@click="quickSampling">
			<span class="e-button__inner">{{ orderSampleLabel }}</span>
		</button>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { track_add_to_cart, track_begin_checkout } from 'shared/services/tracking/basketTrackingService';

export default {
	props: {
		productCode: {
			type: String,
			required: true,
		},
		hasSamplePlaceholder: {
			type: String,
			required: true,
		},
		orderSampleLabel: {
			type: String,
			required: true,
		},
		pageType: {
			type: String,
			required: true,
		},
		productName: {
			type: String,
			required: true,
		},
		productBrandName: {
			type: String,
			required: true,
		},
		category: {
			type: String,
			required: true,
		},
		variantName: {
			type: String,
			required: true,
		}
	},
	computed: {
		...mapGetters({
			basket: 'getBasket',
		}),
		urlKeyForTracking() {
			return `${this.productCode}:${this.productName}`;
		},
	},
	methods: {
		...mapActions({
			fetchBasket: 'fetchBasket',
			addQuickSampleToBasket: 'addQuickSampleToBasket'
		}),
		async quickSampling() {
			try {
				const sampleResponse = await this.addQuickSampleToBasket({
					productCodes: [this.productCode],
				})

				track_add_to_cart(sampleResponse);

				await this.fetchBasket();
				track_begin_checkout(this.basket, { quick_link: 'yes' });

				window.location.assign(sampleResponse.basketUrl);
			} catch(error) {
				console.error(error);
			}
		},
	}
}
</script>
